import React from "react";
import { Navigate } from "react-router-dom";

const FeedbackCreate = () => {
  return <Navigate to="/feedback?feedbackTabs=submit" replace />;
};

export default FeedbackCreate;
